module.exports = "<h2 #focusItem tabindex=\"-1\">{{form.stepTitle}}</h2> <p>{{form.content}}</p> ";